/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Partner_Org_Kpi_Members_Of_ContractInputs */



/**
* | output |
* | --- |
* | "of {total} contracted seats" |
*
* @param {Partner_Org_Kpi_Members_Of_ContractInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_members_of_contract = /** @type {((inputs: Partner_Org_Kpi_Members_Of_ContractInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Members_Of_ContractInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von ${i?.total} vereinbarten Plätzen`)
	return /** @type {LocalizedString} */ (`of ${i?.total} contracted seats`)
});